<script setup>
defineProps({
  isMobileMenuOpen: Boolean,
});
</script>

<template>
  <button
    type="button"
    class="group flex h-12 min-w-[66px] flex-col items-center justify-center rounded-full border border-white bg-white shadow-sm transition hover:border-yellow-600 focus:border-yellow-600"
    :class="{ 'border-yellow-600': isMobileMenuOpen }"
  >
    <span class="sr-only">Open main menu</span>
    <span
      class="block h-0.5 w-5 rounded-sm bg-black transition-all duration-300 ease-out group-hover:bg-yellow-600 group-focus:bg-yellow-600"
      :class="{
        'translate-y-1 rotate-45 bg-yellow-600': isMobileMenuOpen,
        '-translate-y-0.5': !isMobileMenuOpen,
      }"
    ></span>
    <span
      class="my-0.5 block h-0.5 w-5 rounded-sm bg-black transition-all duration-300 ease-out group-hover:bg-yellow-600 group-focus:bg-yellow-600"
      :class="{
        'opacity-0': isMobileMenuOpen,
        'opacity-100': !isMobileMenuOpen,
      }"
    ></span>
    <span
      class="block h-0.5 w-5 rounded-sm bg-black transition-all duration-300 ease-out group-hover:bg-yellow-600 group-focus:bg-yellow-600"
      :class="{
        '-translate-y-1 -rotate-45 bg-yellow-600': isMobileMenuOpen,
        'translate-y-0.5': !isMobileMenuOpen,
      }"
    ></span>
  </button>
</template>
